import React from 'react';
import { GoalSummaryLayout } from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/GoalSummary/GoalSummaryLayout';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDStack } from '@facet-wealth/design';

const OnboardingGoalSummary = () => {
  const { loadOnboardingStepCollection, refreshOnboardingStepCollection } = useSurveyContext();
  const { onSubmit: onSubmitMetaForm } = useMetaLayoutContext();

  const handleAddMoreGoals = async (rel) => {
    await loadOnboardingStepCollection(rel.link('related'));
  };

  const handleDeleteItem = async (resource) => {
    await resource.delete();
    await refreshOnboardingStepCollection();
  };

  const handleEditItem = async (rel) => {
    await loadOnboardingStepCollection(rel.link('related'));
  };

  return (
    <FDStack direction={'column'} spacing={4} alignItems={'center'} width={'100%'}>
      <GoalSummaryLayout onAdd={handleAddMoreGoals} onDeleteItem={handleDeleteItem} onEditItem={handleEditItem} />
      <SurveyStepFooter onSubmit={onSubmitMetaForm} />
    </FDStack>
  );
};

OnboardingGoalSummary.defaultProps = {};

OnboardingGoalSummary.propTypes = {};

export { OnboardingGoalSummary };
